import React from "react"
import {Link, StaticQuery, graphql} from "gatsby"
import styled from '@emotion/styled'

import Layout from "../components/layout"
import SEO from "../components/seo"
import AnchorButton from '../components/AnchorButton'
import ServicesList from '../components/ServicesList'

/*
const ItemContainer = styled.div`
  display: flex;
  flex-direction: column;
  position: relative;
  background: #fff;
  padding: 2.5rem;
  margin: 6rem 0.5rem;

  > h2 {
    xxx_border: 1px solid lime;
    position: relative;
    font-family: 'Oswald', sans-serif;
    font-weight: 500;
    letter-spacing: -0.5rem;
    color: #f7f6f8;
    font-size: 7rem;
    z-index: 10;

    > h1 {
      top: 0;
      left: 0.25rem;
      position: absolute;
      xxx_border: 1px solid blue;
      font-family: 'Vollkorn', serif;
      font-size: 2rem;
      font-weight: 600;
      xxx_height: 6ex;
      line-height: 46px;
      z-index: 11;
      top: 55%;
      transform: translateY(-50%);
    }
  }

  > ${AnchorButton} {
    align-self: flex-start;
  }
`

const ServiceItem = ({index, node}) => (
  <ItemContainer>
    <h2>
      {index.toString().padStart(2, '0')}
      <h1>{node.frontmatter.title}</h1>
    </h2>
    <p>{node.excerpt}</p>
    <AnchorButton to={node.fields.slug}>Read more</AnchorButton>
  </ItemContainer>
)

const ServicesListContainer = styled.div`
  display: flex;
`

const ServicesList = ({services}) => (
  <ServicesListContainer>
    {
      services.map(({ node }, index) => <ServiceItem key={node.id} index={index + 1} node={node} />)
    }
  </ServicesListContainer>
)

const query = graphql`
  query {
    allMarkdownRemark(filter: {fields: {category: {eq: "services"}}}) {
      edges {
        node {
          id
          excerpt(pruneLength: 130)
          frontmatter {
            title
          }
          fields {
            slug
            category
          }
        }
      }
    }
  }
`
*/

export default () => (
  <Layout>
    <div style={{marginTop: '3rem', marginBottom: '3rem'}}>
      <ServicesList />
    </div>
  </Layout>
)